/*(function() {
    'use strict';

    var fileUpload = function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var onChange = $parse(attrs.ngFiles);
                element.on('change', function (event) {
                    onChange(scope, {$files: event.target.files});
                });
            }
        };
    }

    angular.module('app').directive('ngFiles', fileUpload);
}());
*/